import React from "react";

const WishlistHeader = () => {
  return (
    <div className="cart-header-row desktop-only">
      <div>Sản phẩm</div>
      <div>Giá bán</div>
      <div>Chức năng</div>
      <div className="text-center"></div>
    </div>
  );
};

export default WishlistHeader;
